export const POST_TOKEN = 'POST_TOKEN';
export const LOG_OUT = 'LOG_OUT';
export const LOG_IN = 'LOG_IN'

import { postToken } from '../api';

export const login = (e) => (dispatch, getState) => {
  e.preventDefault();

  const { email, password } = getState().ui.loginForm;

  dispatch({
    type: LOG_IN,
    payload: postToken(email, password).then((data) => { localStorage.setItem('token', data.access_token); return data; })
  });
}

export const logOut = () => {
  localStorage.setItem('token', null)
  return {
    type: LOG_OUT
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js